import React from 'react';
import {getLeague} from "@/shared/utils/users";
import {useStore} from "@/app/providers/StoreProvider";
import {IGameInfo, ILeague, leagueType} from "@/entities/user/types";
import ImgBronzeLeague from "@/shared/pictures/bronze_league.png";
import ImgSilverLeague from "@/shared/pictures/silver_league.png";
import ImgGoldLeague from "@/shared/pictures/gold_league.png";

const getImgLeague = (gameInfo:IGameInfo,league: ILeague[]) => {
    const type = getLeague(gameInfo,league).type;
    switch(type){
        case leagueType.Bronze:
            return <img className='statistic-item_img' src={ImgBronzeLeague} alt="" />
        case leagueType.Silver:
            return <img className='statistic-item_img' src={ImgSilverLeague} alt="" />
        case leagueType.Gold:
            return <img className='statistic-item_img' src={ImgGoldLeague} alt="" />
        default:
            const exhaustiveCheck: never = type;
            return exhaustiveCheck;
    }
}
export const ProfileStatisticWidget = () => {
    const {userStore} = useStore();
    const { gameInfo, league } = userStore;
    return (
        <div className='statistic'>
            <div className='statistic-items'>

                <div className='statistic-item'>
                    <h3 className='statistic-item_title'>{getLeague(gameInfo,league).text}</h3>
                    {getImgLeague(gameInfo,league)}
                </div>

                <div className='statistic-item'>
                    <h3 className='statistic-item_title'>Попыток использовано</h3>
                    <p className='statistic-item_count'>{gameInfo.user.totalShoots}</p>
                </div>

                <div className='statistic-item'>
                    <h3 className='statistic-item_title'>Забитых шайб</h3>
                    <p className='statistic-item_count'>{gameInfo.user.score}</p>
                </div>

                <div className='statistic-item'>
                    <h3 className='statistic-item_title'>Процент точности</h3>
                    <p className='statistic-item_count'>{Math.floor(gameInfo.user.accurateRate*100)}%</p>
                </div>

                <div className='statistic-item'>
                    <h3 className='statistic-item_title'>Серия попаданий</h3>
                    <p className='statistic-item_count'>{gameInfo.user.currentStreak}</p>
                </div>

                <div className='statistic-item'>
                    <h3 className='statistic-item_title'>Дней подряд в игре</h3>
                    <p className='statistic-item_count'>{gameInfo.user.daysGameStreak}</p>
                </div>

            </div>
        </div>
    );
};

